module.exports = '346789ABCDEFGHJKLMNPQRTUVWXYabcdefghijkmnpqrtwxyz';